import { RouterLink } from 'design-system/src/components/Button/Button';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { useId } from 'react';
import styled from 'styled-components';

export type PrescriptionLink = {
  id: string;
  name: string;
};

const StyledLink = styled(RouterLink)`
  color: var(--dark-gray);
`;
const StyledList = styled.ul`
  margin: 4px 0 0 0;
  padding-left: 24px;

  li {
    margin-bottom: 2px;
    padding-left: 8px;
  }
  li::marker {
    color: var(--dark-gray);
  }
`;

/**
 * Used to display a list of prescription links
 */
export const PrescriptionLinkList: React.FC<{
  prescriptions: PrescriptionLink[];
}> = ({ prescriptions }) => {
  const labelId = useId();
  return (
    <div>
      <Typography id={labelId} styledAs="bodyDMSans" weight={600}>
        Multiple prescriptions ({prescriptions.length})
      </Typography>
      <StyledList aria-labelledby={labelId}>
        {prescriptions.map((prescription) => (
          <li key={prescription.id}>
            <StyledLink to={`/rxs/${prescription.id}`}>{prescription.name}</StyledLink>
          </li>
        ))}
      </StyledList>
    </div>
  );
};
